import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './BottomNavBar.module.css';

const navItems = [
  {
    label: 'Matcher',
    to: '/transactions',
    icon: (
      <span style={{ fontSize: '2rem', lineHeight: 1 }}>📊</span>
    )
  },
  {
    label: 'Games',
    to: '/games',
    icon: (
      <span style={{ fontSize: '2rem', lineHeight: 1 }}>🎮</span>
    )
  },
  {
    label: 'Quests',
    to: '/',
    icon: (
      <span style={{ fontSize: '2rem', lineHeight: 1 }}>🏁</span>
    )
  },
  {
    label: 'Home',
    to: '/home',
    icon: (
      <span style={{ fontSize: '2rem', lineHeight: 1 }}>🏠</span>
    )
  },
  {
    label: 'Profile',
    to: '/profile',
    icon: (
      <span style={{ fontSize: '2rem', lineHeight: 1 }}>👤</span>
    )
  }
];

const BottomNavBar: React.FC = () => {
  const location = useLocation();

  return (
    <nav className={styles.bottomNavBar}>
      {navItems.map((item) => {
        const isActive = location.pathname === item.to;
        return (
          <Link key={item.label} to={item.to} className={styles.navItem + (isActive ? ' ' + styles.active : '')}>
            <div className={styles.iconWrapper}>
              {item.icon}
              {isActive && <span className={styles.dot} />}
            </div>
            <span className={styles.label}>{item.label}</span>
          </Link>
        );
      })}
    </nav>
  );
};

export default BottomNavBar; 